import BaseModel from './baseModel';

class ArticleModel extends BaseModel {
  // constructor(refs) {
  //   super(refs);
  //   this.Id;
  //   this.Title;
  //   this.Abstract;
  //   this.SelectedTags;
  //   this.Tags;
  //   this.Images;
  //   this.SelectedImages;
  // }
}

export default ArticleModel;


/** WEBPACK FOOTER **
 ** ./src/models/article.js
 **/